import React from "react";

const UserTypedResponse = ({ TypedResponse, responseType, onEdit }) => {
    const isEditable = ["selection", "confirmation", "PAN", "GST", "loan_amount", "Aadhar", "COMP_PAN"].includes(responseType);

    return (
        <div className="user-typed-response">
            <div className="user-type-response">
                <div className="user-type-response-content">{TypedResponse}</div>
                {isEditable && (
                    <div className="user-edit-icon" onClick={onEdit}>
                        <img src="/images/edit-icon.png" alt="edit-icon" />
                    </div>
                )}
            </div>
            <div className="user-profile-icon">
                <img src="/images/profile-icon.png" alt="profile-icon" />
            </div>
        </div>
    );
};

export default UserTypedResponse;
